import { useAtomValue } from 'jotai';
import { FreeTrialStep } from './typings';
import { freeTrialStepAtom } from './states';
import TrialDetailsModal from './TrialDetailsModal';
import GrantAccessModal from './GrantAccessModal';
import TrialEndedModal from './TrialEndedModal';

export default function CallFreeTrial() {
  const step = useAtomValue(freeTrialStepAtom);

  if (step === FreeTrialStep.Closed) {
    return null;
  }

  if (step === FreeTrialStep.GrantAccess) {
    return <GrantAccessModal />;
  }

  if (step === FreeTrialStep.TrialEnded) {
    return <TrialEndedModal />;
  }

  return <TrialDetailsModal />;
}
